import {
    AfterViewInit,
    Component,
    OnDestroy,
    OnInit,
    ViewChild
} from '@angular/core';
import { EntityCollectionService, EntityServices } from '@ngrx/data';
import { select, Store } from '@ngrx/store';
import clone from 'just-clone';
import { combineLatest, Observable, ReplaySubject } from 'rxjs';
import { map, takeWhile } from 'rxjs/operators';
import * as fromDataServices from '../../data-services';
import * as fromCommon from '../../shared';
import * as fromShared from '../../shared';
import { LoggingService } from '../../shared/services/logging/logging.service';
import { ClassPresenterComponent } from '../presenter/class-presenter.component';
import * as fromActions from '../store/contract-class.actions';
import { ContractClass } from '../store/contract-class.model';
import * as fromReducer from '../store/contract-class.reducer';
@Component({
    selector: 'ef-class-feature',
    templateUrl: './class-feature.component.html',
    styleUrls: ['./class-feature.component.scss'],
    standalone: false
})
export class ClassFeatureComponent implements OnInit, AfterViewInit, OnDestroy {
    process$: Observable<fromShared.Process>;

    @ViewChild(ClassPresenterComponent, { static: true })
    presenter: ClassPresenterComponent;

    public contractClasses$: Observable<ContractClass[]>;
    public contracts$: Observable<fromDataServices.Contract.Contract[]>;

    selectedError$: Observable<fromShared.Errors.IShowErrors>;
    selectedErrorWithStatus$: Observable<fromCommon.IStatusMessage>;

    active = true;
    dataService: EntityCollectionService<fromDataServices.Contract.Contract>;
    ShowError = new ReplaySubject<fromShared.Errors.IShowErrors>(1);

    constructor(
        public entityServices: EntityServices,
        private log: LoggingService,
        private store: Store<fromReducer.State>
    ) {
        this.dataService =
            entityServices.getEntityCollectionService<fromDataServices.Contract.Contract>(
                fromDataServices.Contract.entityName
            );
    }

    ngOnInit(): void {
        this.dataService.getAll();
        // this.store.dispatch(fromLookups.ContractActions.getContracts());
        this.setupObservables();
    }

    ngAfterViewInit(): void {}

    ngOnDestroy(): void {
        this.active = false;
        this.store.dispatch(fromActions.clearContractClasss());
    }

    setupObservables() {
        this.process$ = this.store.pipe(select(fromShared.selectCurrent));

        this.contractClasses$ = this.store.pipe(
            select(fromReducer.selectAll),
            map(x => clone(x))
        );

        this.contracts$ = this.dataService.entities$.pipe(
            map(x => (x = x.filter(y => y.IsActive === true))),
            map(x => clone(x)),
            map(x =>
                x.sort((a, b) => a.ContractDesc.localeCompare(b.ContractDesc))
            )
        );
        combineLatest([this.process$, this.ShowError])
            .pipe(takeWhile(() => this.active))
            .subscribe(([process, event]) => {
                this.store.dispatch(
                    new fromShared.Errors.SetShowErrors({
                        open: event.open,
                        MsgEntityID: event.MsgEntityID,
                        MsgProcessID: process.ProcessID
                    })
                );
            });
    }

    onLoadContractClasses($event) {
        this.log.verbose({
            type: 'ClassFeatureComponent:onLoadContractClasses'
        });
        this.store.dispatch(
            fromActions.postContractClass({ ContractListID: $event })
        );
    }

    onSaveContractClasses($event) {
        this.log.verbose({
            type: 'ClassFeatureComponent:onSaveContractClasses'
        });
        this.store.dispatch(
            fromActions.putContractClass({ contractClasses: $event })
        );
    }
}
